import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { C } from './styles/theme';

export default function ProtectedRoute({ children, role }) {
  const { currentUser } = useApp();
  const navigate = useNavigate();
  if (!currentUser || (role && currentUser.role !== role)) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 24px', animation: 'fadeIn 0.4s ease' }}>
        <div style={{ fontSize: 48, marginBottom: 16, color: C.navy }}>🔒</div>
        <h2 style={{ fontFamily: "'Outfit', sans-serif", color: C.navy, marginBottom: 8 }}>Access Restricted</h2>
        <p style={{ color: C.g400, marginBottom: 24 }}>Please sign in{role ? ` as ${role === 'organizer' ? 'an organizer' : 'a player'}` : ''} to continue.</p>
        <button onClick={() => navigate('/login')} style={{ background: C.lime, color: C.navy, border: 'none', padding: '12px 32px', borderRadius: 6, fontWeight: 700, cursor: 'pointer', fontSize: 14, letterSpacing: 0.5, textTransform: 'uppercase' }}>Sign In</button>
      </div>
    );
  }
  return children;
}
